import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="logo">
        <a href="https://dlskiturl.com/CardCreator/" style={{
          textDecoration: "none",
          color: "#fff",
          fontSize: "1.5rem",
          fontWeight: "bold"
        }}>DLS Card Creator</a>
      </div>
      {/* <ul className="nav-links">
        <li>Home</li>
        <li>Kits</li>
        <li>Leagues</li>
        <li>Tutorials</li>
        <li>App</li>
        <li>Creator</li>
        <li>Stats</li>
      </ul> */}
    </nav>
  );
};

export default Navbar;
